import { render, staticRenderFns } from "./Jawn.vue?vue&type=template&id=36cb8193&scoped=true&"
import script from "./Jawn.vue?vue&type=script&lang=js&"
export * from "./Jawn.vue?vue&type=script&lang=js&"
import style0 from "./Jawn.vue?vue&type=style&index=0&id=36cb8193&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb8193",
  null
  
)

export default component.exports